import React, { Component } from 'react';
import PropTypes from 'prop-types';


class ActionButtonOfCaseLookup extends Component {
  render() {
    return (
      <div
        onClick={this.props.onClick}
        className="form-item"
        style={{ display: 'inline-block', width: 'auto' }}>
        <a className="form-submit" style={{ left: '15px' }}>
                    <span
                      style={{
                        background: "url(/sites/all/themes/inforuptcy/icons/small-white-magnifier.png) center no-repeat",
                        padding: "2px 0 0 16px"
                      }}>
                    </span>
        </a>
      </div>
    )
  }
}

ActionButtonOfCaseLookup.defaultProps = {
  onClick: () => {
  },
};

ActionButtonOfCaseLookup.propTypes = {
  onClick: PropTypes.func,
};


export default ActionButtonOfCaseLookup



// WEBPACK FOOTER //
// ./src/components/search/FormElements/ActionButtonOfCaseLookup/ActionButtonOfCaseLookup.js